export default "__VITE_ASSET__DqE51W_T__"